module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.93b37a4.ttf";